import React from "react";
import { Navigation } from "./navigation";
import { Footer } from "./footer";
import { EventPhoto } from "./event-photo";
import "./news.css";

export const InsightDetailPage = ({ item, onHome, onOpenPage, contact }) => {
  if (!item) return null;

  const openPage = (event, route) => {
    if (!onOpenPage) return;
    event.preventDefault();
    onOpenPage(route);
  };

  return (
    <div className="insight-detail-page news-article-page">
      <Navigation detailMode detailModeType="insights" onHome={onHome} onOpenPage={onOpenPage} />
      <main>
        <article className="news-story container">
          <header className="news-story-header">
            <a className="news-back" href="#/insights" data-scroll-ignore onClick={event => openPage(event, "insights")}>
              <i className="fa fa-angle-left" aria-hidden="true" /> News &amp; Insights
            </a>
            <div className="news-meta">
              <span>{item.type}</span>
              <time dateTime={item.dateTime}>{item.date}</time>
              <span>{item.location}</span>
            </div>
            <h1>{item.title}</h1>
            <p className="news-standfirst">{item.summary}</p>
          </header>
          <EventPhoto photo={item.cover} priority />
          <p className="news-introduction news-reading-width">{item.introduction}</p>
          {item.sections.map(section => (
            <section className="news-story-section" key={section.heading}>
              <div className="news-reading-width">
                <h2>{section.heading}</h2>
                {(section.paragraphs || [section.body]).map(paragraph => <p key={paragraph}>{paragraph}</p>)}
              </div>
              <EventPhoto photo={section.photo} />
            </section>
          ))}
          <div className="news-reading-width">
            <p className="news-source">{item.sourceNote}</p>
            <aside className="news-related" aria-label="Related products">
              <span className="news-eyebrow">OUR PRODUCTS</span>
              <h2>Explore Goldly AI's agent applications</h2>
              <p>Discover Shiye Agent, Super Agent and our industry applications, supported by model access and cloud infrastructure.</p>
              <a href="#/agent-platform" className="news-read-link" data-scroll-ignore onClick={event => openPage(event, "agent-platform")}>
                Explore AI Agents <i className="fa fa-arrow-right" aria-hidden="true" />
              </a>
            </aside>
            <a className="news-back" href="#/insights" data-scroll-ignore onClick={event => openPage(event, "insights")}>
              <i className="fa fa-angle-left" aria-hidden="true" /> All news &amp; insights
            </a>
          </div>
        </article>
      </main>
      <Footer contact={contact} onHome={onHome} />
    </div>
  );
};
